import React, { useState, useEffect } from 'react';

import Table from 'rsuite/Table';
import Pagination from 'rsuite/Pagination';
import Input from 'rsuite/Input';
import InputGroup from 'rsuite/InputGroup';
import Loader from 'rsuite/Loader';
import Tag from 'rsuite/Tag';
import { Popover, Dropdown, Whisper, IconButton } from 'rsuite';
import MoreIcon from '@rsuite/icons/legacy/More';
import SearchIcon from '@rsuite/icons/Search';
import AddOutlineIcon from '@rsuite/icons/AddOutline';

/*------------- OTHERS ------------------------------------*/
import { useSelector, useDispatch } from 'react-redux';
import { requestCertAsync, updateCertAsync, selectData, selectIsLoading } from 'slices/certSlice';

/*------------- CUSTOM ------------------------------------*/
import 'Components/Admin/Certificado/grid.css';
import NewCertificadoModal from '../NewCertificado/NewCertificadoModal';
import SectionPanel from 'Components/Common/SectionPanel/SectionPanel';
import { CompactCell } from 'Components/Common/Table/CustomCells';

const { Column, Cell, HeaderCell } = Table;

const ActionCell = ({ rowData, dataKey, onSelect, ...props }) => {

  const  renderMenu = ({ onClose, left, top, className }, ref) => {

    const handleSelect = eventKey => {
      onClose();
      onSelect(eventKey, rowData);
    };
  
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={1}>
            Activar Certificado
          </Dropdown.Item>
          <Dropdown.Item eventKey={2}>
            Desactivar Certificado
          </Dropdown.Item>          
        </Dropdown.Menu>
      </Popover>
    );
  
  }
  
  return (
    <CompactCell {...props}>
      <Whisper placement="autoVerticalEnd" trigger="click" speaker={renderMenu}>
        <IconButton size="xs" appearance="subtle" icon={<MoreIcon />}></IconButton>
      </Whisper>
    </CompactCell>
  );
};

export default function CertificadoTable() {
  const dispatch = useDispatch();
  const loading = useSelector(selectIsLoading);
  const [openModalForm, setOpenModalForm] = useState(false);
  const [dataModel, setDataModel] = useState(null);

  const [limit, setLimit] = React.useState(14);
  const [page, setPage] = React.useState(1);

  const [filter, setFilter] = useState({
    search: '',
    numberPage: page,
    sizePage: limit,
  });
  const certificados = useSelector(selectData);

  const renderLoading = () => {
    return (
      <div>
        <Loader backdrop center content="Cargado" />
      </div>
    );
  };

  /**
   *
   * @param {string} - Valor de input
   */
  const handleSearch = (value) => {
    setFilter({ ...filter, search: value });
  };

  const handleOpenModal = () => {
    setDataModel(null);
    setOpenModalForm(true);
  };

  /**
   * @description Event - Abrir la modal de permisos
   * @param {*} eventKey
   * @param {*} event
   */
  function handleSelectMenu(eventKey, data, event) {
    switch (eventKey) {
      case 0:        
        break;
      case 1:
        dispatch(updateCertAsync({ id: data.fileId, estatus: 1 }));        
        break;
      case 2:
        dispatch(updateCertAsync({ id: data.fileId, estatus: 3 }));        
        break;
      default:
        break;
    }
  }

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
    dispatch(requestCertAsync({ pagination: { NumberPage: page, SizePage: dataKey } }));
  };

  const handleChangePage = (val) => {
    setPage(val);
    dispatch(requestCertAsync({ pagination: { NumberPage: val, SizePage: limit } }));
  };

  useEffect(() => {
    dispatch(requestCertAsync({ pagination: { NumberPage: page, SizePage: limit } }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SectionPanel
      title={
        <div className="table__hader">
          <h4>Configuración de certificados</h4>
          <div>
            <IconButton appearance="primary" icon={<AddOutlineIcon />} onClick={handleOpenModal}>
              Nuevo Certificado
            </IconButton>
          </div>
        </div>
      }
    >
      <div>
        <NewCertificadoModal isOpen={openModalForm} setOpen={setOpenModalForm} data={dataModel} />
        <div className="table__hader">
          <div>
            <InputGroup className="table__header-input">
              <Input placeholder="Buscar" onChange={handleSearch} />
              <InputGroup.Button>
                <SearchIcon />
              </InputGroup.Button>
            </InputGroup>
          </div>
        </div>
        <Table data={certificados.items} height={500} loading={loading} renderLoading={renderLoading}>
          <Column flexGrow={1}>
            <HeaderCell>Emisor NIT</HeaderCell>
            <Cell fullText dataKey="nit" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>Nombre de archivo</HeaderCell>
            <Cell fullText dataKey="fileName" />
          </Column>
          {/* <Column flexGrow={1}>
            <HeaderCell>Vigencia desde</HeaderCell>
            <Cell fullText dataKey="inicioVigencia" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>Vigencia Hasta</HeaderCell>
            <Cell fullText dataKey="finVigencia" />
          </Column> */}
          <Column flexGrow={1}>
            <HeaderCell>Estatus</HeaderCell>
            <Cell>
              {(rowData) =>
                rowData.estatus === 0 ? (
                  <Tag color="yellow">Pendiente</Tag>
                ) : rowData.estatus === 1 ? (
                  <Tag color="green">Activo</Tag>
                ) : rowData.estatus === 2 ? (
                  <Tag color="green">Activo</Tag>
                ) : rowData.estatus === 3 ? (
                  <Tag color="red">Revocado</Tag>
                ) : (
                  '-'
                )
              }
            </Cell>
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>
              Acciones
            </HeaderCell>
            <ActionCell dataKey="id" onSelect={handleSelectMenu} />
          </Column>
        </Table>
        <div style={{ padding: 20 }}>
          <Pagination
            first
            next
            total={certificados.recordsTotal}
            limit={limit}
            activePage={page}
            onChangeLimit={handleChangeLimit}
            onChangePage={handleChangePage}            
          />
        </div>
      </div>
    </SectionPanel>
  );
}
